import { apiFetcher } from './api'
import { apiAllFetcher } from './apiAll'
import { strapiFetcher } from './strapi'

// SWR fetchers. See https://swr.vercel.app/docs/data-fetching
export default {
  api: apiFetcher,
  apiAll: apiAllFetcher,
  strapi: strapiFetcher,
}
